import { useSocureBaseLogic } from '@Hooks/socure/useSocureBaseLogic';
import { useBoundStore } from '@Store/useBoundStore';
import { useAuthUserDocVStatusPolling } from './useAuthUserDocVStatusPolling';
import { useResendAuthUserDocV } from './useResendAuthUserDocV';
import type { SocureLogicHookResult } from '@Pages/happyFlowPages/NonUsSocure/NonUSSocurePage';

export const useAuthUserDocVLogic = (): SocureLogicHookResult => {
  const { customerId, authorizedUserId } = useBoundStore.getState().onboardingSlice;

  const {
    refetch: resendDocV,
    isFetching: isSendingResend,
    data: resendData,
  } = useResendAuthUserDocV(customerId, authorizedUserId);

  const {
    openResendOption,
    isSuccessNotificationVisible,
    setIsSuccessNotificationVisible,
    errorMessage,
    timeLeft,
    onSendSmsClick,
    isLoadingSms,
  } = useSocureBaseLogic({
    resendDocVFn: resendDocV,
    isSending: isSendingResend,
  });

  useAuthUserDocVStatusPolling({
    customerId,
    authorizedUserId,
  });

  return {
    onSendSmsClick,
    openResendOption,
    timeLeft,
    isLoading: isLoadingSms,
    errorMessage,
    socureQR: resendData?.qrCode,
    isSuccessNotificationVisible,
    setIsSuccessNotificationVisible,
  };
};
